//const baseURL = "http://localhost:8080/";
const baseURL = "https://console.athenaanalytics.io/api/";

export default baseURL;